import script from "./fileUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./fileUpload.vue?vue&type=script&setup=true&lang=js"

import "./fileUpload.vue?vue&type=style&index=0&id=82a6c8bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82a6c8bc"]])

export default __exports__